import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Confirm, Grid, Loader } from 'semantic-ui-react';
import moment from 'moment';
import { contractActions } from '../../actions/contract.actions';

class ContractShowScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      submitted: false,
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(contractActions.getById(match.params.id));
  }

  handleCancel = () => this.setState({ open: false });

  deleteShow = () => this.setState({ open: true });

  deleteById() {
    const { match, dispatch } = this.props;

    dispatch(contractActions.deleteById(match.params.id)).then(() =>
      this.props.history.push('/contracts'),
    );
  }

  editById() {
    const { match } = this.props;
    this.props.history.push(`/contracts/${match.params.id}/edit`);
  }

  render() {
    const { contracts, loading } = this.props;
    const { open } = this.state;

    if (!contracts || !contracts.item) {
      return <Loader active={loading} />;
    }

    const periodLabel =
      contracts.item.period === 'C'
        ? 'Contrato'
        : contracts.item.period === 'A'
        ? 'Anual'
        : 'Mensal';

    return (
      <Fragment>
        <Confirm
          content="Deseja remover esse item?"
          open={open}
          onCancel={this.handleCancel}
          onConfirm={() => this.deleteById()}
        />

        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={10} computer={10}>
            <h1>Contrato</h1>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={6} computer={6} textAlign="right">
            <Button icon="edit outline" onClick={() => this.editById()} />
            <Button icon="trash alternate outline" onClick={this.deleteShow} />
          </Grid.Column>
        </Grid>
        <div className="container-inner">
          <h4>Cliente: </h4>
          {contracts.item.client ? contracts.item.client.name : ''}
          <h4>Tipo: </h4>
          {contracts.item.type ? contracts.item.type.name : ''}
          <h4>Produto: </h4>
          {contracts.item.product ? contracts.item.product.name : ''}
          <h4>Data Início: </h4>
          {moment(contracts.item.start_date).format('DD/MM/YYYY')}
          <h4>Data Fim: </h4>
          {moment(contracts.item.finish_date).format('DD/MM/YYYY')}
          <h4>Quantidade de Horas: </h4>{' '}
          {moment.duration(contracts.item.hours_qty, 'hours').format('HH:mm')}
          <h4>Periodicidade: </h4> {periodLabel}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { contracts } = state;
  return {
    contracts,
    loading: contracts.loading || false,
  };
}

const connectedContractShowScreen = connect(mapStateToProps)(ContractShowScreen);
export { connectedContractShowScreen as ContractShowScreen };
